import { useCallback } from 'react';
import { useWithModalForm } from 'shared/common/hooks/useWithModalForm';
import { useApplicationContext } from 'shared/common/utils/applicationContext';
import { useVisibilityTracking } from 'shared/common/hooks/useVisibilityTracking';
import { HowItWorks } from 'shared/landingBuyer/components/HowItWorks';
import { showBuyerHowItWork } from '../../utils/tracking';

export const HowItWorksContainer: React.FC = () => {
  const { handleOpenModal } = useWithModalForm();
  const { custom } = useApplicationContext();

  const handleHowItWorksVisible = useCallback(() => {
    showBuyerHowItWork(custom);
  }, [custom]);

  const visibilityRef = useVisibilityTracking({
    onVisible: handleHowItWorksVisible,
    threshold: 0,
    once: true,
  });

  return (
    <div ref={visibilityRef}>
      <HowItWorks onOpenModal={handleOpenModal} context={custom} />
    </div>
  );
};
